<!-- Option C: 이미지들을 순서대로 표시하고 각각 ai-image-edit-overlay로 감싸서 편집 -->
<div class="desc-img-editor" *ngIf="isAdminPage && images.length > 0">
  <div class="desc-img-editor__header" (click)="toggleExpanded()">
    <div class="desc-img-editor__header-left">
      <span class="desc-img-editor__title">📷 상세설명 이미지 편집</span>
      <span class="desc-img-editor__count">{{ images.length }}개</span>
    </div>
    <span class="desc-img-editor__toggle" [class.expanded]="isExpanded">▶</span>
  </div>

  <div class="desc-img-editor__list" *ngIf="isExpanded">
    <div *ngFor="let image of images; let i = index" class="desc-img-editor__item">
      <ai-image-edit-overlay
        [imageUrl]="image.url"
        [imageKey]="getImageKey(i)"
        [showEditButton]="true"
        (imageUpdated)="onImageUpdatedByIndex(i, $event)"
      >
        <img [src]="image.url" [alt]="'상세설명 이미지 ' + (i + 1)" class="desc-img-editor__image" />
      </ai-image-edit-overlay>
      <div class="desc-img-editor__number">{{ i + 1 }}</div>
    </div>
  </div>
</div>
